import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { NavLink } from 'react-router-dom';

import styles from './SidebarNavItem.scss';

SidebarNavItem.propTypes = {
    soon: PropTypes.bool,
    isMarked: PropTypes.bool,
    label: PropTypes.string,
    title: PropTypes.string,
    as: PropTypes.elementType,
};

SidebarNavItem.defaultProps = {
    soon: false,
    as: NavLink,
};

export default function SidebarNavItem({ as: Component, soon, isMarked, title, label, children, ...rest }) {
    const componentProps = {
        className: classNames(styles.root, {
            [styles.soon]: soon,
            [styles.marked]: isMarked,
        }),
        'data-nav': title || label,
        title: title || label,
        ...rest,
    };

    if (Component === NavLink) {
        componentProps.activeClassName = styles.active;
    }

    return (
        <Component {...componentProps}>
            <div className={styles.iconContainer}>{children}</div>
            {label && (
                <span>
                    {label}
                    {soon && <i> (soon)</i>}
                </span>
            )}
        </Component>
    );
}
